// extracted by mini-css-extract-plugin
export default {"l_WasteBasket_main":"WasteBasket_l_WasteBasket_main__miAB9","l_WasteBasket_icon":"WasteBasket_l_WasteBasket_icon__tjodl"};